import { useMutation, useQueryClient } from '@tanstack/react-query'
import { WorkspaceSummary } from '../../features/workspaces/types'
import { getQueryKey } from '../../services'
import { showErrorToast } from '@bpinternal/ui-kit-next'
import { handleHttpErrors } from '../../shared'
import { getApiClient } from '../../stores'

type DeleteWorkspaceParams = { onSuccess?: (workspaceId: string) => void } & Parameters<
  ReturnType<typeof getApiClient>['deleteWorkspace']
>['0']

export function useDeleteWorkspace() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: DeleteWorkspaceParams) => {
      return await getApiClient().deleteWorkspace({ id }).catch(handleHttpErrors)
    },
    onSuccess: async (_, { onSuccess, id }) => {
      queryClient.setQueryData<WorkspaceSummary[]>(
        getQueryKey('workspaces_'),
        (old: WorkspaceSummary[] | undefined) => {
          if (old) {
            return old.filter((w) => w.id !== id)
          }
          return old
        }
      )

      const workspaceQueryKey = getQueryKey('workspaces_/$workspaceId_', { workspaceId: id })
      queryClient.removeQueries({ queryKey: workspaceQueryKey })

      onSuccess?.(id)
    },
    onError: (error: Error) => {
      showErrorToast(error.message)
    },
  })
}
